"use strict";

require("core-js/modules/es6.string.anchor");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _useKeydown = _interopRequireDefault(require("../hooks/useKeydown"));

var _useLockBodyScroll = _interopRequireDefault(require("../hooks/useLockBodyScroll"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'overlay';

  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors;

  return {
    root: {
      position: 'fixed',
      zIndex: 1300,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    background: {
      position: 'fixed',
      zIndex: -1,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: colors[color]
    }
  };
};
/**
 * A Backdrop is a fixely positionned component that prevents user's scroll
 *  and focuses attention on its contents (Dialog, Popover, etc.)
 */


__signature__(useStyles, "useTheme{{ colors }}", function () {
  return [_useTheme2["default"]];
});

var Backdrop = function Backdrop(props) {
  var _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 150 : _props$timeout,
      color = props.color,
      containerProps = props.containerProps,
      anchor = props.anchor,
      open = props.open,
      onClose = props.onClose,
      className = props.className,
      style = props.style,
      children = props.children;
  var ref = (0, _react.useRef)(null);
  var classes = useStyles(color);
  /** Compute if we should close the Backdrop */

  var handleOnClick = (0, _react.useCallback)(function (e) {
    /** No click events should traverse the Backdrop */
    e.stopPropagation();
    /** If the ref is the target, we should close */

    if (onClose && e.target === ref.current) {
      onClose();
    }
  }, [onClose]);
  /** Lock the body scroll */

  (0, _useLockBodyScroll["default"])(open);
  /** Close on the Escape press */

  (0, _useKeydown["default"])('Escape', onClose);
  return (0, _core.jsx)(_Portal["default"], {
    anchor: anchor
  }, (0, _core.jsx)(_Fade["default"], {
    "in": open,
    timeout: timeout
  }, (0, _core.jsx)("div", {
    role: "presentation",
    css: classes.root,
    className: className,
    style: style
  }, (0, _core.jsx)("div", (0, _extends2["default"])({
    ref: ref,
    "data-testid": "Backdrop",
    onClick: handleOnClick,
    css: classes.background
  }, containerProps), children))));
};

__signature__(Backdrop, "useRef{ref}\nuseStyles{classes}\nuseCallback{handleOnClick}\nuseLockBodyScroll{}\nuseKeydown{}", function () {
  return [useStyles, _useLockBodyScroll["default"], _useKeydown["default"]];
});

var _default = Backdrop;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Backdrop/index.tsx");
  reactHotLoader.register(Backdrop, "Backdrop", "/builds/bA1zbJom/0/gojob/ui-bits/src/Backdrop/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Backdrop/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();